var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 25.846 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.99,10H17.5L14.925,2.3a.935.935,0,0,0-1.754,0L10.592,10H2.048a.926.926,0,0,0-.923.923.678.678,0,0,0,.017.156.887.887,0,0,0,.387.652L8.5,16.641,5.827,24.424a.926.926,0,0,0,.317,1.038.893.893,0,0,0,.519.225,1.131,1.131,0,0,0,.577-.208l6.808-4.852,6.808,4.852a1.081,1.081,0,0,0,.577.208.829.829,0,0,0,.513-.225.914.914,0,0,0,.317-1.038l-2.677-7.783L26.5,11.68l.167-.144a.968.968,0,0,0,.3-.617A.977.977,0,0,0,25.99,10Zm-7.338,5.337a1.62,1.62,0,0,0-.588,1.835l1.737,5.06a.232.232,0,0,1-.352.265l-4.465-3.185a1.612,1.612,0,0,0-.94-.3,1.582,1.582,0,0,0-.935.3L8.642,22.486a.231.231,0,0,1-.352-.265l1.737-5.06a1.626,1.626,0,0,0-.594-1.846L4.76,12.02a.232.232,0,0,1,.133-.421h5.694a1.613,1.613,0,0,0,1.529-1.1l1.708-5.088a.232.232,0,0,1,.438,0L15.969,10.5A1.613,1.613,0,0,0,17.5,11.6h5.613a.228.228,0,0,1,.133.415Z",
    transform: "translate(-1.125 -1.688)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "images/star.f6682995.svg";
export { ForwardRef as ReactComponent };